import { Props_SnippetMapContent } from "./MapContent.props";
import SharedHeading from "../Shared/Heading/Heading";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const SnippetMapContent = (props: Props_SnippetMapContent) => {
  const { heading, snippet } = props;

  if (!snippet) {
    return null;
  }

  const { MapUrl, Address, OpeningHours } = snippet;

  const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

   
  console.log('Destructured MapUrl:', MapUrl);
  console.log('Destructured Address:', Address);
  console.log('Destructured OpeningHours:', OpeningHours);
  
  
  return (
    <section className="snippet-map-content">
      <div className="snippet-map-content__container">
        <div className="snippet-map-content__map-container">
          <iframe
            src={MapUrl?.value || ''}
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Location Map"
            className="snippet-map-content__map"
          ></iframe>
        </div>
        <div className="snippet-map-content__info-container">
            <SharedHeading
          className="snippet-map-content__heading"
          level={headingLevel}
          alignment={heading.alignment?.value as "start" | "center" | "end"}
          visibility={
            typeof heading.visibility?.value === "boolean"
              ? heading.visibility.value
              : heading.visibility?.value === "true"
          }
        >
          {heading.text?.value}
        </SharedHeading>
          {Address?.value && (
            <div className="snippet-map-content__address">
              {CompileMarkdown(Address.value)}
            </div>
          )}
          {OpeningHours?.value && (
            <div className="snippet-map-content__opening-hours">
              {CompileMarkdown(OpeningHours.value)}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SnippetMapContent;